<template>
  <div class="list" name="add" v-loading="loading2">
    <el-card style="margin-bottom:20px" shadow="never">
      <el-form label-width="100px" :model="addForm" :rules="rule_data" ref="addForm" class="addAgentForm">
        <h3 size="medium">基本信息</h3>
        <el-form-item label="登录账号" prop="FAgentAccount">
          <el-input v-model="addForm.FAgentAccount" clear style="width: 30%" placeholder="8~20位数字或字母"></el-input>
          <auth-button opt="check_agent" icon="el-icon-search" class="check" @click.native="checkSubAg" :loading="checkLoading" label="检测"></auth-button>
        </el-form-item>
        <el-form-item label="登录密码" prop="FAgentPassword">
          <el-input v-model="addForm.FAgentPassword" clear style="width: 30%" placeholder="8-20位大写/小写字母/数字/符号中的至少三种组合"></el-input>
        </el-form-item>
        <el-form-item label="代理商名称" prop="FTitle">
          <el-input v-model="addForm.FTitle" clear style="width: 30%" placeholder="请输入代理商名称"></el-input>
        </el-form-item>
        <el-form-item label="绑定手机" prop="FMobile">
          <el-input v-model="addForm.FMobile" clear style="width: 30%" placeholder="请输入绑定手机"></el-input >
        </el-form-item>
        <el-form-item label="渠道身份" prop="channelAgentId" required>
          <el-select v-model="addForm.channelAgentId" clear placeholder="请选择渠道身份">
            <el-option v-for="item in AgentIdOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务线" prop="professionalFlag" required>
          <el-select v-model="addForm.professionalFlag" clear placeholder="请选择业务线">
            <el-option v-for="item in lineBusinessOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-divider/>
        <el-form label-width="80px" inline label-position="left">
          <h3 size="medium" >成本信息</h3>
          <el-form-item label="成本设置">
            <el-select v-model="selectedTemplate" @change="rateTemplateSelectChange">
              <el-option label="自定义" :value="-1" :key="-1"></el-option>
              <el-option :label="template.name" :value="template.id" v-for="template in rateTemplateList" :key="template.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分成比例" size="large" label-width="50px;" v-show="ruleType == 0">
            <el-input v-model="addForm.FLowerDivideCent" class="LowerDivideCent" @change="subLowerDivideCent"><template slot="append">%</template></el-input>
          </el-form-item>
          <div class="" v-loading="saleLoading" v-show="ruleType == 1">
            <label style="line-height: 40px;padding-right: 12px;color: #606266;font-size: 14px;">刷卡费率</label>
            <el-table :data="cardTable" border size="small" align="center" style="width:900px;" :span-method="editTemplateTableSpanMethod">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)"/><span>%</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Max" label="D+1封顶手续费" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1Max" @blur="onRateBlur(scope.row.d1Max)" v-if="scope.row.d1Max !== '--'"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0" label="D+0费率" width="150" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0 !== '--'">
                    <input :class="scope.row.d0" @blur="onRateBlur(scope.row.d0)" />
                    <span slot="suffix">%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Fixed" label="D+0单笔手续费" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d0Fixed" @blur="onRateBlur(scope.row.d0Fixed)" v-if="scope.row.d0Fixed !== '--'"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Fixed" label="额外收取下级分成比例" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.posLower" @blur="onRateBlur(scope.row.posLower)"/>
                  <span>%</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item label="扫码成本" size="large" label-width="50px;" v-show="ruleType == 1" style="margin-top: 30px"></el-form-item>
          <div style="margin-top: -10px">
            <el-form-item label="额外收取下级分成比例" size="large" label-width="50px;" v-show="ruleType == '1'">
              <div>
                <input class="scanLowerDivideCent" @blur="onRateBlur('scanLowerDivideCent')"/>
                <span style="float: right;height: 40px;line-height: 40px;">%</span>
              </div>
            </el-form-item>
          </div>
          <el-table :data="scanWechatTable" border size="small" align="center" style="width:1080px;">
            <el-table-column prop="type" label="微信费率" align="center">
              <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1 !== '--'">
                    <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)" />
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="d0" label="D+0费率" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.d0 !== '--'">
                  <input :class="scope.row.d0" @blur="onRateBlur(scope.row.d0)" />
                  <span>%</span>
                </div>
                <span v-else>——</span>
              </template>
            </el-table-column>
          </el-table>
          <el-collapse v-model="showWechat" style="width:720px;margin-bottom: 20px;border-bottom: none">
            <el-collapse-item title="多通道费率" name="1">
              <el-table :data="scanWechatMulti" border size="small" align="center" style="width:1080px;">
                <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1L" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)">
                      <input :class="scope.row.typeLetterL + '_' + scope.row.d1L"
                        :disabled="dataParam.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''"
                        @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                          ? 't1WeixinCommission'
                          : 't1AlipayCommission', scope.row.typeLetterL + '.' + scope.row.d1L)" />
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
                <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1R" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)">
                      <input :class="scope.row.typeLetterR + '_' + scope.row.d1R"
                        :disabled="dataParam.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''"
                        @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                          ? 't1WeixinCommission'
                          : 't1AlipayCommission', scope.row.typeLetterR + '.' + scope.row.d1R)" />
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="showRihua" style="width:360px;margin-bottom: 20px;border-bottom: none">
            <el-collapse-item title="服饰日化费率" name="1">
              <el-row class="row">
                <el-col class="item">费用类型</el-col>
                <el-col class="item">D+1费率</el-col>
              </el-row>
              <el-row class="row">
                <el-col class="item">服饰日化-借记卡</el-col>
                <el-col class="item">
                  <el-input v-model="rihuaEntity.wxCategoryDebitCommissionD1">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </el-row>
              <el-row  class="row">
                <el-col class="item">服饰日化-贷记卡</el-col>
                <el-col class="item">
                  <el-input v-model="rihuaEntity.wxCategoryCreditCommissionD1">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <el-table :data="scanAlipayTable" border size="small" align="center" style="width:1080px;">
            <el-table-column prop="type" label="支付宝费率" align="center">
              <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1 !== '--'">
                    <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)" />
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0" label="D+0费率" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0 !== '--'">
                    <input :class="scope.row.d0" @blur="onRateBlur(scope.row.d0)" />
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-collapse v-model="showAlipay" style="width:1080px;margin-bottom: 20px;border-bottom: none">
            <el-collapse-item title="多通道费率" name="1">
              <el-table :data="scanAlipayMulti" border size="small" align="center" style="width:1080px;">
                <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1L" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)">
                      <input :class="scope.row.typeLetterL + '_' + scope.row.d1L"
                        :disabled="dataParam.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''"
                        @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                          ? 't1WeixinCommission'
                          : 't1AlipayCommission', scope.row.typeLetterL + '.' + scope.row.d1L)" />
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
                <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1R" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)">
                      <input :class="scope.row.typeLetterR + '_' + scope.row.d1R"
                        :disabled="dataParam.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''"
                        @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                          ? 't1WeixinCommission'
                          : 't1AlipayCommission', scope.row.typeLetterR + '.' + scope.row.d1R)" />
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
          <el-form-item label="银联二维码" size="large" label-width="50px;" v-show="ruleType == 1"></el-form-item>
          <div class="" v-loading="saleLoading" v-show="ruleType == 1">
            <el-table :data="unionpayTable" border size="small" align="center"
              style="width:800px;"
              :span-method="editTemplateTableSpanMethod">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率>1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1 !== '--'">
                    <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)"/>
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Level2" label="D+1费率≤1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1Level2 !== '--'">
                    <input :class="scope.row.d1Level2" @blur="onRateBlur(scope.row.d1Level2)"/>
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Max" label="D+1封顶手续费" width="180" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1Max" @blur="onRateBlur(scope.row.d1Max)" v-if="scope.row.d1Max !== '--'"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0" label="D+0费率>1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0 !== '--'">
                    <input :class="scope.row.d0" @blur="onRateBlur(scope.row.d0)"/>
                    <!-- <el-input-number :controls="false" :max='0.6' v-model="defaultDataParam[scope.row.d0]" :class='defaultDataParam[scope.row.d0]' @blur="onRateBlur(scope.row.d0)"> -->
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Level2" label="D+0费率≤1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0Level2 !== '--'">
                    <input :class="scope.row.d0Level2" @blur="onRateBlur(scope.row.d0Level2)"/>
                    <!-- <el-input-number :controls="false" :max='0.6' v-model="defaultDataParam[scope.row.d0Level2]" :class='defaultDataParam[scope.row.d0Level2]' @blur="onRateBlur(scope.row.d0Level2)"/> -->
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="posLower" label="额外收取下级分成比例" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.posLower" @blur="onRateBlur(scope.row.posLower)"/>
                  <span>%</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item label="扫码点餐类扫码费率" size="large" label-width="50px;" style="margin-top: 10px"></el-form-item>
          <div class="two-table">
            <div class="cutom-table">
              <div class="row title">
                <div class="item left">费用类型</div>
                <div class="item">D+1费率</div>
              </div>
              <div class="row">
                <div class="item left">微信</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1WeixinIncrementCommission" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
              <div class="row">
                <div class="item left">支付宝</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1AlipayIncrementCommission" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
            </div>
            <div class="cutom-table">
              <div class="row title">
                <div class="item left">费用类型</div>
                <div class="item">D+1费率&gt;1000元</div>
                <div class="item">D+1封顶手续费</div>
                <div class="item">D+1费率≤1000元</div>
              </div>
              <div class="row">
                <div class="item left">借记卡</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayGt1000DebitIncrementRate" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayDebitIncrementMaxFee" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayDebitIncrementRate" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
              <div class="row">
                <div class="item left">贷记卡</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayGt1000CreditIncrementRate" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">——</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayCreditIncrementRate" class="LowerDivideCent" @change="subLowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-divider/>
        <h3 size="medium">结算信息（非单独入账可不填）</h3>
        <el-form-item label="账户类型" prop="FBankAccountType">
          <el-select v-model="addForm.FBankAccountType" style="width: 120px;" placeholder="" clearable>
            <el-option label="个人" value="1"></el-option>
            <el-option label="公司" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开户名" prop="FBankAccount" style="width: 30%;">
          <el-input v-model="addForm.FBankAccount" ></el-input>
        </el-form-item>
        <el-form-item label="开户人身份证" prop="FIdentityCard" style="width: 30%;">
          <el-input v-model="addForm.FIdentityCard" clear></el-input>
        </el-form-item>
        <el-form-item label="银行卡号" prop="FBankCardid" style="width: 30%;">
          <el-input v-model="addForm.FBankCardid" clear></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="FBankType">
          <el-select style="width: 23.5%;" placeholder="" clearable filterable v-model="addForm.FBankType" @change="setBankName" prop="FBankType">
            <el-option v-for="item in bank_list" :key="item.F_bank_name_code" :label="item.F_bank_name" :value="item.F_bank_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行网点" prop="FBankArea">
          <el-select style="width:120px;" placeholder="请选择省" clearable filterable v-model="addForm.FBankArea" @change="setBankPro" prop="FBankArea">
            <el-option v-for="item in pro_list" :key="item.F_bank_area_code" :label="item.F_bank_area" :value="item.F_bank_area"></el-option>
          </el-select>
          <el-select v-model="addForm.FBankCity" placeholder="请选择市" @change="setBankCity" clearable style="width: 120px;" prop="FBankCity">
            <el-option v-for="item in city_list" :key="item.F_bank_city_code" :label="item.F_bank_city" :value="item.F_bank_city"></el-option>
          </el-select>
          <el-autocomplete
            class="inline-input branch-input branch"
            v-model="addForm.FBankPoint"
            :fetch-suggestions="querySearch"
            placeholder="分行网点"
            @select="handleSelect"
            prop="FBankPoint"
            clearable></el-autocomplete>
        </el-form-item>
        <el-form-item label="预留手机号" prop="FBankMobile" style="width: 30%;">
          <el-input v-model="addForm.FBankMobile" clear></el-input>
        </el-form-item>
      </el-form>
      <auth-button opt="submit" icon="el-icon-circle-plus-outline" @click.native="onSubmit('addForm')" class="submit" :loading="addLoading" label="立即创建"></auth-button>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
import { checkSubAg, addSubAgent, getAgFee, getTemplateList, getTemplate, listChannel } from '@/api/partner'
import md5 from 'js-md5'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'

const topRateNum = 50 // 代理商成本、商户费率默认封顶值
const topFeeNum = 500 // 代理商成本、商户手续费默认封顶值

export default {
  name: 'AddAgent',
  data () {
    return {
      defaultDataParam: {
        t0WeixinCommission: '',
        t0AlipayCommission: '',
        fT0DebitCommissionBymillion: '',
        fT0BelowDebitCommissionBymillion: '',
        fT0CreditCommissionBymillion: '',
        fT0BelowCreditCommissionBymillion: ''
      },
      AgentIdOptions: [],
      rule_data: {
        FAgentAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入登录账号'))
            } else {
              if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入8-20位数字或字母'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FAgentPassword: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FTitle: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入代理商名称'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2-40位的中文代理商名称'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value))) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FBankAccountType: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请选择账户类型'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入开户名'))
            } else {
              if (this.addForm.FBankAccountType === '1') {
                if (/^[\u4e00-\u9fa5()（）]{2,6}$/.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入2-6位中文姓名'))
                }
              } else {
                if (/^[\u4e00-\u9fa5()（）]{2,40}$/.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入2-40位开户名'))
                }
              }
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FIdentityCard: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入身份证号码'))
            } else {
              if (!(/^\d{17}(\d|\w){1}$/.test(value))) {
                callback(new Error('身份证号码输入有误'))
              } else {
                callback()
              }
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankCardid: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入银行卡号'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankType: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入开户行'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankArea: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入省名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankCity: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入市名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankPoint: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入区名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value))) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: false,
          trigger: 'blur'
        }]
      },
      // 新增界面数据
      addForm: {
        FAgentAccount: '',
        FAgentPassword: '',
        FTitle: '',
        FMobile: '',
        channelAgentId: '',
        professionalFlag: 0,
        FBankAccountType: '',
        FBankAccount: '',
        FIdentityCard: '',
        FBankCardid: '',
        FBankType: '',
        FBankArea: '',
        FBankCity: '',
        FBankPoint: '',
        FBankMobile: '',
        insertFlag: '1', // 新建
        t1DebitCommission: '',
        t1DebitMaxFee: '',
        t0DebitCommission: '',
        t1CreditCommission: '',
        t0CreditCommission: '',
        t1OverSeasCommission: '',
        t0OverSeasCommission: '',
        t0FixFee: '',
        t1WeixinCommission: '',
        t0WeixinCommission: '',
        t1AlipayCommission: '',
        t0AlipayCommission: '',
        t1UnionpayDebitRate: '',
        t0UnionpayDebitRate: '',
        t1UnionpayCreditRate: '',
        t0UnionpayCreditRate: '',
        t0UnionpayCreditRateLevel2: '',
        t0UnionpayDebitRateLevel2: '',
        t1UnionpayOverseasRate: '',
        t0UnionpayOverseasRate: '',
        unionLowerDivideCent: '',
        posLowerDivideCent: '',
        scanLowerDivideCent: '',
        FLowerDivideCent: '',
        extraFeeRate: ''
      },

      domain: 'https://baseweb.lszzg.com/',
      bank_list: [],
      pro_list: [],
      city_list: [],
      branch_list: [],
      areas: [],
      citys: [],
      data: [],
      t1DebitCommission: '',
      proCity_list: [],
      cityForm: {
        f_custom: '0',
        f_parent_code: '',
        f_code: '',
        f_name: ''
      },
      lineBusinessOptions: [{
        value: 0,
        label: '其它'
      }, {
        value: 1,
        label: '专业市场'
      }],
      tableData1: [],
      dataParam: {
        extraFeeRate: {
          alipay: {
            activityFee0: '', // 活动0
            activityFee1: '', // 活动1
            bluesea: '', // 蓝海
            online: ''// 线上
          },
          wechat: {
            collegeCanteen: '', // 高校食堂
            insurance: '', // 保险
            oasis: '', // 绿洲
            online: '', // 线上
            privateSchool: '', // 私立学校
            publicPayment: '', // 公缴
            publicWeal: ''// 公益
          }
        }
      },
      checkLoading: false,
      addLoading: false,
      seloading: false,
      saleLoading: false,
      loading2: false,
      ruleType: '',
      selectedTemplate: -1,
      rateTemplateList: [],
      originPsd: '', // 加密前的密码
      cardTable: [
        {
          type: '借记卡',
          d1: 't1DebitCommission',
          d1Max: 't1DebitMaxFee',
          d0: 't0DebitCommission',
          d0Fixed: 't0FixFee',
          posLower: 'posLowerDivideCent'
        },
        {
          type: '贷记卡',
          d1: 't1CreditCommission',
          d1Max: '--',
          d0: 't0CreditCommission',
          d0Fixed: '--'
        },
        {
          type: '境外卡',
          d1: 't1OverSeasCommission',
          d1Max: '--',
          d0: 't0OverSeasCommission',
          d0Fixed: '--'
        }
      ],
      scanWechatTable: [
        {
          extraType: '线下（默认）',
          d1: 't1WeixinCommission',
          d0: 't0WeixinCommission',
          posLower: 'scanLowerDivideCent'
        }
      ],
      showWechat: [],
      showRihua: [],
      scanWechatMulti: [
        {
          extraTypeL: '绿洲',
          d1L: 'oasis',
          typeLetterL: 'wechat',
          extraTypeR: '公益',
          d1R: 'publicWeal',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '高校食堂',
          d1L: 'collegeCanteen',
          typeLetterL: 'wechat',
          extraTypeR: '公缴',
          d1R: 'publicPayment',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '私立中小幼',
          d1L: 'privateSchool',
          typeLetterL: 'wechat',
          extraTypeR: '保险',
          d1R: 'insurance',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'wechat',
          extraTypeR: '——',
          d1R: '--',
          typeLetterR: 'wechat'
        }
      ],
      scanAlipayTable: [
        {
          d1: 't1AlipayCommission',
          d0: 't0AlipayCommission',
          extraType: '线下（默认）'
        }
      ],
      showAlipay: [],
      scanAlipayMulti: [
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'alipay',
          extraTypeR: '蓝海活动',
          d1R: 'bluesea',
          typeLetterR: 'alipay'
        },
        {
          extraTypeL: '行业活动0',
          d1L: 'activityFee0',
          typeLetterL: 'alipay',
          extraTypeR: '行业活动1',
          d1R: 'activityFee1',
          typeLetterR: 'alipay'
        }
      ],
      unionpayTable: [
        {
          type: '借记卡',
          d1: 'fT1DebitCommissionBymillion',
          d1Max: 'fT1UnionpayDebitMaxCharge',
          d1Level2: 'fT1BelowDebitCommissionBymillion',
          d0: 'fT0DebitCommissionBymillion',
          d0Level2: 'fT0BelowDebitCommissionBymillion',
          posLower: 'unionLowerDivideCent'
        },
        {
          type: '贷记卡',
          d1: 'fT1CreditCommissionBymillion',
          d1Max: '--',
          d1Level2: 'fT1BelowCreditCommissionBymillion',
          d0: 'fT0CreditCommissionBymillion',
          d0Level2: 'fT0BelowCreditCommissionBymillion'
        }
      ],
      scanOrder: {
        t1WeixinIncrementCommission: '',
        t1AlipayIncrementCommission: '',
        t1UnionpayCreditIncrementRate: '',
        t1UnionpayDebitIncrementRate: '',
        t1UnionpayDebitIncrementMaxFee: '',
        t1UnionpayGt1000CreditIncrementRate: '',
        t1UnionpayGt1000DebitIncrementRate: ''
      },
      rihuaEntity: {
        wxCategoryDebitCommissionD1: '', // 服饰日化-借记卡
        wxCategoryCreditCommissionD1: '' // 服饰日化-贷记卡
      },
      extraFeeRate: {
        alipay: {
          activityFee0: '', // 活动0
          activityFee1: '', // 活动1
          bluesea: '', // 蓝海
          online: ''// 线上
        },
        wechat: {
          collegeCanteen: '', // 高校食堂
          insurance: '', // 保险
          oasis: '', // 绿洲
          online: '', // 线上
          privateSchool: '', // 私立学校
          publicPayment: '', // 公缴
          publicWeal: ''// 公益
        }
      }
    }
  },
  methods: {
    // 添加代理商渠道身份
    getAgentIdOptions () {
      listChannel().then(res => {
        res.data.forEach(item => {
          this.AgentIdOptions.push({ value: item.frameId, label: item.frameName + ' ' + item.frameId })
        })
      })
    },
    // 检测账号可用性
    checkSubAg () {
      var FAgent = this.addForm.FAgentAccount
      if (FAgent === '') {
        this.$message({ message: '请输入登录账号.' })
        return false
      };
      FAgent = { FAgentAccount: FAgent }
      FAgent = qs.stringify(FAgent)
      this.checkLoading = true
      checkSubAg(FAgent).then(data => {
        this.checkLoading = false
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    onSubmit (addForm) {
      var that = this
      if (that.ruleType === 1 && !that.checkRate()) {
        return false
      }
      var t1DebitCommission = Math.round((this.$jquery('.t1DebitCommission').val()) * 100)
      var t1DebitMaxFee = Math.round((this.$jquery('.t1DebitMaxFee').val()) * 1000000)
      var t0DebitCommission = Math.round((this.$jquery('.t0DebitCommission').val()) * 100)
      var t1CreditCommission = Math.round((this.$jquery('.t1CreditCommission').val()) * 100)
      var t0CreditCommission = Math.round((this.$jquery('.t0CreditCommission').val()) * 100)

      var t1OverSeasCommission = Math.round((this.$jquery('.t1OverSeasCommission').val()) * 100)
      var t0OverSeasCommission = Math.round((this.$jquery('.t0OverSeasCommission').val()) * 100)
      var t0FixFee = Math.round((this.$jquery('.t0FixFee').val()) * 1000000)
      var posLowerDivideCent = Math.round(this.$jquery('.posLowerDivideCent').val())

      var t1WeixinCommission = Math.round((this.$jquery('.t1WeixinCommission').val()) * 100)
      var t0WeixinCommission = Math.round((this.$jquery('.t0WeixinCommission').val()) * 100)
      var t1AlipayCommission = Math.round((this.$jquery('.t1AlipayCommission').val()) * 100)
      var t0AlipayCommission = Math.round((this.$jquery('.t0AlipayCommission').val()) * 100)
      var scanLowerDivideCent = Math.round(this.$jquery('.scanLowerDivideCent').val())

      var t1UnionpayDebitRate = Math.round((this.$jquery('.fT1DebitCommissionBymillion').val()) * 100)
      var t1UnionpayCreditRate = Math.round((this.$jquery('.fT1CreditCommissionBymillion').val()) * 100)
      var t0UnionpayDebitRate = Math.round((this.$jquery('.fT0DebitCommissionBymillion').val()) * 100)
      var t0UnionpayCreditRate = Math.round((this.$jquery('.fT0CreditCommissionBymillion').val()) * 100)
      var t0UnionpayCreditRateLevel2 = Math.round(this.$jquery('.fT0BelowCreditCommissionBymillion').val() * 100)
      var t0UnionpayDebitRateLevel2 = Math.round(this.$jquery('.fT0BelowDebitCommissionBymillion').val() * 100)
      var t1UnionpayBelowDebitRate = Math.round(this.$jquery('.fT1BelowDebitCommissionBymillion').val() * 100)
      var t1UnionpayBelowCreditRate = Math.round(this.$jquery('.fT1BelowCreditCommissionBymillion').val() * 100)
      var unionLowerDivideCent = Math.round(this.$jquery('.unionLowerDivideCent').val())

      var t1UnionpayDebitMaxCharge = Math.round(this.$jquery('.fT1UnionpayDebitMaxCharge').val() * 1000000)
      for (const key in that.extraFeeRate.alipay) {
        that.extraFeeRate.alipay[key] = this.$jquery('.' + 'alipay_' + key).val() !== '' ? Math.round((this.$jquery('.' + 'alipay_' + key).val()) * 100) : ''
      }
      for (const key in that.extraFeeRate.wechat) {
        that.extraFeeRate.wechat[key] = this.$jquery('.' + 'wechat_' + key).val() !== '' ? Math.round((this.$jquery('.' + 'wechat_' + key).val()) * 100) : ''
      }
      console.log(that.extraFeeRate)
      that.addForm.t1DebitCommission = t1DebitCommission
      that.addForm.t1DebitMaxFee = t1DebitMaxFee
      that.addForm.t0DebitCommission = t0DebitCommission
      that.addForm.t1CreditCommission = t1CreditCommission
      that.addForm.t0CreditCommission = t0CreditCommission
      that.addForm.t1OverSeasCommission = t1OverSeasCommission
      that.addForm.t0OverSeasCommission = t0OverSeasCommission
      that.addForm.t0FixFee = t0FixFee
      that.addForm.posLowerDivideCent = posLowerDivideCent

      that.addForm.t1WeixinCommission = t1WeixinCommission
      that.addForm.t0WeixinCommission = t0WeixinCommission
      that.addForm.t1AlipayCommission = t1AlipayCommission
      that.addForm.t0AlipayCommission = t0AlipayCommission
      that.addForm.scanLowerDivideCent = scanLowerDivideCent

      that.addForm.t1UnionpayDebitRate = t1UnionpayDebitRate
      that.addForm.t1UnionpayCreditRate = t1UnionpayCreditRate
      that.addForm.t1UnionpayOverseasRate = 260
      that.addForm.t0UnionpayDebitRate = t0UnionpayDebitRate
      that.addForm.t0UnionpayCreditRate = t0UnionpayCreditRate
      that.addForm.t0UnionpayOverseasRate = 300
      that.addForm.t1UnionpayDebitRateLevel2 = t1UnionpayBelowDebitRate
      that.addForm.t1UnionpayCreditRateLevel2 = t1UnionpayBelowCreditRate
      that.addForm.t0UnionpayCreditRateLevel2 = t0UnionpayCreditRateLevel2
      that.addForm.t0UnionpayDebitRateLevel2 = t0UnionpayDebitRateLevel2
      that.addForm.unionLowerDivideCent = unionLowerDivideCent

      that.addForm.t1UnionpayDebitMaxCharge = t1UnionpayDebitMaxCharge

      // 新增扫码点餐类字段
      that.addForm.t1WeixinIncrementCommission = Math.round(that.scanOrder.t1WeixinIncrementCommission * 100)
      that.addForm.t1AlipayIncrementCommission = Math.round(that.scanOrder.t1AlipayIncrementCommission * 100)
      that.addForm.t1UnionpayCreditIncrementRate = Math.round(that.scanOrder.t1UnionpayCreditIncrementRate * 100)
      that.addForm.t1UnionpayDebitIncrementRate = Math.round(that.scanOrder.t1UnionpayDebitIncrementRate * 100)
      that.addForm.t1UnionpayDebitIncrementMaxFee = Math.round(that.scanOrder.t1UnionpayDebitIncrementMaxFee * 1000000)

      that.addForm.t1UnionpayGt1000DebitIncrementRate = Math.round(that.scanOrder.t1UnionpayGt1000DebitIncrementRate * 100)
      that.addForm.t1UnionpayGt1000CreditIncrementRate = Math.round(that.scanOrder.t1UnionpayGt1000CreditIncrementRate * 100)

      // 日化
      that.addForm.wxCategoryDebitCommissionD1 = Math.round(that.rihuaEntity.wxCategoryDebitCommissionD1 * 100)
      that.addForm.wxCategoryCreditCommissionD1 = Math.round(that.rihuaEntity.wxCategoryCreditCommissionD1 * 100)

      Object.keys(that.addForm).forEach(item => {
        if (this.isEmpty(that.addForm[item])) {
          delete that.addForm[item]
        }
      })
      that.addForm.extraFeeRate = JSON.stringify(that.extraFeeRate)

      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        var pw = this.addForm.FAgentPassword
        this.originPsd = this.addForm.FAgentPassword
        this.addLoading = true
        this.loading2 = true
        let para = Object.assign({}, this.addForm)
        para = JSON.parse(JSON.stringify(para))
        if (pw) {
          para.FAgentPassword = md5(pw)
        }
        para = qs.stringify(para)
        addSubAgent(para).then(data => {
          this.addLoading = false
          this.loading2 = false
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.$refs.addForm.resetFields()
            that.addForm.extraFeeRate = ''
            that.$router.push('/Agent/Info')
          } else {
            this.addForm.FAgentPassword = this.originPsd// 将密码恢复成未加密前
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.addForm.FAgentPassword = this.originPsd// 将密码恢复成未加密前
        })
      })
    },
    // 判空
    isEmpty (val) {
      if (typeof val === 'undefined' || val === null || val === '') {
        return true
      } else {
        return false
      }
    },
    // 校验费率
    checkRate () {
      if (this.onRateBlur('fT1DebitCommissionBymillion') &&
          this.onRateBlur('fT1UnionpayDebitMaxCharge') &&
          this.onRateBlur('fT1BelowDebitCommissionBymillion') &&
          this.onRateBlur('fT1CreditCommissionBymillion') &&
          this.onRateBlur('fT1BelowCreditCommissionBymillion')) {
        return true
      }
      return false
    },
    changeProvince () {
      this.citys = []
      this.cityForm.f_code = ''
      if (this.cityForm.f_parent_code === '') {
        return false
      }
      var query = this.cityForm.f_parent_code
      let obj = {}
      obj = this.proCity_list.find((item) => {
        return item.f_code === query
      })
      this.citys = obj.f_city_list
    },

    // 获取银行列表
    getBank () {
      var that = this
      this.$jquery.ajax({
        type: 'POST',
        asyn: false,
        url: that.domain + 'leposweb/home/getbanknamecode.do',
        contentType: 'application/json; charset=utf-8',
        dataType: 'jsonp',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.bank_list = eval(json.list)
        }
      })
    },
    // 获取省列表
    getPro () {
      var that = this
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        url: that.domain + 'leposweb/home/getbankareacode.do',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.pro_list = eval(json.list)
        }
      })
    },
    // 获取市列表
    getCity () {
      var that = this
      var bankAreaCode = this.addForm.FBankAreaCode
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        data: { bankAreaCode: bankAreaCode },
        url: that.domain + 'leposweb/home/getbankcitycode.do?',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.city_list = eval(json.list)
        }
      })
    },
    // 设置银行名称
    setBankName (value) {
      let obj = {}
      obj = this.bank_list.find((item) => {
        return item.F_bank_name === value
      })
      this.addForm.FBankType = value
      this.addForm.FBankTypeCode = obj.F_bank_name_code
      if (this.addForm.FBankTypeCode && this.addForm.f_bank_city_code) {
        this.getBranchList()
      }
      console.log(this.addForm)
    },
    // 设置省
    setBankPro (value) {
      let obj = {}
      obj = this.pro_list.find((item) => {
        return item.F_bank_area === value
      })
      this.addForm.FBankArea = value
      this.addForm.FBankAreaCode = obj.F_bank_area_code
      if (this.addForm.FBankAreaCode) {
        this.getCity()
      }
      console.log(this.addForm)
    },
    // 设置市
    setBankCity (value) {
      let obj = {}
      obj = this.city_list.find((item) => {
        return item.F_bank_city === value
      })
      this.addForm.FBankCityCode = obj.F_bank_city_code
      if (this.addForm.FBankCityCode) {
        this.getBranchList()
      }
    },
    // 设置网点
    setBranch (value) {

    },
    getBranchList () {
      var that = this
      var bankNo = this.addForm.FBankTypeCode
      var cityNo = this.addForm.FBankCityCode
      that.seloading = true
      this.$jquery.ajax({
        type: 'POST',
        url: that.domain + 'leposweb/home/getbankbranch2.do',
        data: { bankNo: bankNo, cityNo: cityNo },
        dataType: 'jsonp',
        success: function (json) {
          // eslint-disable-next-line no-eval
          json = eval(json.list)
          if (json.length > 0) {
            that.branch_list = json
            that.seloading = false
          }
        }
      })
    },
    getRate () {
      var that = this
      var data = ''
      data = qs.stringify(data)
      getAgFee(data).then(function (data) {
        if (parseInt(data.error_code) !== 0) {
          that.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          that.ruleType = data.ruleType
          var fRate = data.FRate / 100
          const pos = data.pos
          const scan = data.scan
          const unionpay = data.unionpay

          if (that.ruleType === 0) {
            that.addForm.FLowerDivideCent = ''
          } else {
            that.dataParam.fRate = fRate

            // 以下数据作为默认费率，设置不可低于默认费率
            that.dataParam.t1DebitCommission = (pos.t1DebitCommission) / 100
            that.dataParam.t0DebitCommission = (pos.t0DebitCommission) / 100
            that.dataParam.t1CreditCommission = (pos.t1CreditCommission) / 100
            that.dataParam.t0CreditCommission = (pos.t0CreditCommission) / 100
            that.dataParam.t1OverSeasCommission = (pos.t1OverSeasCommission) / 100
            that.dataParam.t0OverSeasCommission = (pos.t0OverSeasCommission) / 100
            that.dataParam.t1DebitMaxFee = (pos.t1DebitMaxFee) / 1000000
            that.dataParam.t0FixFee = (pos.t0FixFee) / 1000000
            that.dataParam.t1WeixinCommission = (scan.t1WeixinCommission) / 100
            that.dataParam.t1AlipayCommission = (scan.t1AlipayCommission) / 100
            that.dataParam.t0WeixinCommission = (scan.t0WeixinCommission) / 100
            that.dataParam.t0AlipayCommission = (scan.t0AlipayCommission) / 100
            that.dataParam.fT1DebitCommissionBymillion = (unionpay.fT1DebitCommissionBymillion) / 100
            that.dataParam.fT1CreditCommissionBymillion = (unionpay.fT1CreditCommissionBymillion) / 100
            that.dataParam.fT1BelowDebitCommissionBymillion = unionpay.fT1DebitCommissionBymillionLevel2 / 100
            that.dataParam.fT1BelowCreditCommissionBymillion = unionpay.fT1CreditCommissionBymillionLevel2 / 100
            that.dataParam.fT0DebitCommissionBymillion = (unionpay.fT0DebitCommissionBymillion) / 100
            that.dataParam.fT0CreditCommissionBymillion = (unionpay.fT0CreditCommissionBymillion) / 100
            that.dataParam.fT0BelowDebitCommissionBymillion = unionpay.fT0DebitCommissionBymillionLevel2 / 100
            that.dataParam.fT0BelowCreditCommissionBymillion = unionpay.fT0CreditCommissionBymillionLevel2 / 100
            that.dataParam.fT1UnionpayDebitMaxCharge = (unionpay.fT1DebitMaxFeeBymillion) / 1000000

            if (scan.extraFeeRate) {
              const extraFeeRate = JSON.parse(scan.extraFeeRate)
              for (const item in that.dataParam.extraFeeRate.alipay) {
                if (typeof (extraFeeRate.alipay[item]) === 'number') {
                  that.dataParam.extraFeeRate.alipay[item] = (extraFeeRate.alipay[item]) / 100
                } else {
                  that.dataParam.extraFeeRate.alipay[item] = ''
                }
              }
              for (const item in that.dataParam.extraFeeRate.wechat) {
                if (typeof (extraFeeRate.wechat[item]) === 'number') {
                  that.dataParam.extraFeeRate.wechat[item] = (extraFeeRate.wechat[item]) / 100
                } else {
                  that.dataParam.extraFeeRate.wechat[item] = ''
                }
              }
            }

            // 获取扫码点餐类的字段
            that.scanOrder.t1WeixinIncrementCommission = scan.t1WeixinIncrementCommission / 100
            that.scanOrder.t1AlipayIncrementCommission = scan.t1AlipayIncrementCommission / 100
            that.scanOrder.t1UnionpayCreditIncrementRate = unionpay.t1UnionpayCreditIncrementRate / 100
            that.scanOrder.t1UnionpayDebitIncrementRate = unionpay.t1UnionpayDebitIncrementRate / 100
            that.scanOrder.t1UnionpayDebitIncrementMaxFee = unionpay.t1UnionpayDebitIncrementMaxFee / 1000000

            that.scanOrder.t1UnionpayGt1000DebitIncrementRate = unionpay.t1UnionpayGt1000DebitIncrementRate / 100
            that.scanOrder.t1UnionpayGt1000CreditIncrementRate = unionpay.t1UnionpayGt1000CreditIncrementRate / 100

            // 日化
            that.rihuaEntity.wxCategoryDebitCommissionD1 = scan.wxCategoryDebitCommissionD1 / 100
            that.rihuaEntity.wxCategoryCreditCommissionD1 = scan.wxCategoryCreditCommissionD1 / 100
          }
        }
        // 这里做ajax请求
        // 如果数据没有被修改这个回调方法不会执行
      }).catch(() => {
        this.$message({
          showClose: true,
          message: data.error_msg,
          type: 'error'
        })
      })
    },
    // 费率失去光标
    onRateBlur (value, extraValue) {
      console.log('🚀 ~ file: addAgent.vue ~ line 1330 ~ onRateBlur ~ value', value)
      let message = ''
      let numberValue, defaultValue
      if (extraValue) {
        const extraText = extraValue.split('.')
        numberValue = Number(this.$jquery('.' + extraText[0] + '_' + extraText[1]).val())// 格式转换
        defaultValue = this.dataParam.extraFeeRate[extraText[0]][extraText[1]]
        // return true; // 多通道费率先不校验
      } else {
        numberValue = Number(this.$jquery('.' + value).val())// 格式转换
        defaultValue = this.dataParam[value]
      }
      let result = true// 校验结果
      let type = ''// 校验类型
      // 如果费率为空或小于默认值，校验不通过
      if (isNaN(numberValue) || numberValue < defaultValue) {
        result = false
      }
      // 判断类型，根据不同类型进行不同校验
      if (value.toLowerCase().indexOf('t1') >= 0) {
        type = 'T1'
      }
      if (value.toLowerCase().indexOf('t1') >= 0 && value.toLowerCase().indexOf('overseas') >= 0) {
        type = 'T1Overseas'
      }
      if (value.toLowerCase().indexOf('t0') >= 0) {
        type = 'T0'
      }
      if (value.toLowerCase().indexOf('unionpay') >= 0) {
        type = 'UnionRate'
      }
      if (value.toLowerCase().indexOf('t1') >= 0 && value.toLowerCase().indexOf('fee') >= 0) {
        type = 'T1Fee'
      }
      if (value.toLowerCase().indexOf('t0') >= 0 && value.toLowerCase().indexOf('fee') >= 0) {
        type = 'T0Fee'
      }
      if (value.toLowerCase().indexOf('lower') >= 0) {
        type = 'lower'
      }
      // 不同类型的报错信息不一致
      switch (type) {
        case 'T1': {
          message = `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T1Overseas': {
          message = `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T0': {
          message = `D0费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T0Fee': {
          message = '单笔手续费不能为空、小于默认手续费 或超过20'
          if (numberValue > topFeeNum) {
            result = false
          }
          break
        }
        case 'T1Fee': {
          message = `手续费不能为空、小于默认手续费 或 超过${topFeeNum}元`
          if (numberValue > topFeeNum) {
            result = false
          }
          break
        }
        case 'lower': {
          message = '额外收取下级分成比例不能是小数，小于0或者大于100'
          if (numberValue < 0 || numberValue > 100 || Number(numberValue) % 1 !== 0) {
            result = false
          }
          break
        }
        default: {
          message = `当前费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
        }
      }

      if (!result) {
        this.$message({
          showClose: true,
          message: message,
          type: 'warning'
        })
        if (extraValue) {
          const extraText = extraValue.split('.')
          this.$jquery('.' + extraText[0] + '_' + extraText[1]).val(defaultValue)
        } else {
          this.$jquery('.' + value).val(defaultValue)
        }
        return false
      }
      return true
    },
    rounding (n1) {
      return n1.toFixed(2)
    },
    subLowerDivideCent (value) {
      var fLowerDivideCent = Number(value)
      if (fLowerDivideCent < 0 || fLowerDivideCent > 100 || Number(fLowerDivideCent) % 1 !== 0) {
        this.$message({
          showClose: true,
          message: '分成比例不能是小数，小于0或者大于100',
          type: 'warning'
        })
        this.addForm.FLowerDivideCent = ''
      }
    },
    querySearch (queryString, cb) {
      var branchList = []
      var array
      for (var i = 0; i < this.branch_list.length; i++) {
        array = { value: this.branch_list[i].F_branch_name, F_branch_no: this.branch_list[i].F_branch_no }
        branchList.push(array)
      }

      console.log(branchList)

      var results = queryString ? branchList.filter(this.createFilter(queryString)) : branchList
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
      }
    },
    handleSelect (item) {
      this.addForm.branch = item.value
      this.addForm.unionpay = item.F_branch_no
    },
    /**
       * 获取模板下拉列表
       */
    getTemplateList () {
      const params = qs.stringify({
        type: 1
      })
      console.log(params)
      getTemplateList(params).then(response => {
        console.log('getTemplateList response:', response)
        if (response.error_code === '0') {
          this.rateTemplateList = response.data
          if (response.defaultId) {
            this.selectedTemplate = response.defaultId
            this.getTemplate(response.defaultId)
          } else {
            this.selectedTemplate = -1
            this.setTemplateRate()
          }
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 根据id获取模板信息
       */
    getTemplate (id) {
      const params = qs.stringify({
        id: id
      })
      console.log(params)
      getTemplate(params).then(response => {
        console.log('getTemplate response:', response)
        if (response.error_code === '0') {
          this.setTemplateRate({
            fRate: response.fRate,
            ...response.data
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 费率模板选择change
       */
    rateTemplateSelectChange (templateId) {
      if (templateId >= 0) {
        this.getTemplate(templateId)
      } else {
        this.setTemplateRate()
      }
    },
    /**
       * 展示费率模板
       */
    setTemplateRate (rateInfo) {
      if (rateInfo) {
        if (this.ruleType === 0) {
          this.addForm.FLowerDivideCent = rateInfo.fLowerDivideCent / 10000
        } else {
          console.log('🚀 ~ file: addAgent.vue ~ line 1552 ~ setTemplateRate ~ rateInfo', rateInfo)
          const t1Debit = (rateInfo.fT1DebitRate) / 10000
          const t1DebitMax = (rateInfo.fT1DebitFeeMax) / 1000000
          const t1Credit = (rateInfo.fT1CreditRate) / 10000
          const t1OverSeas = (rateInfo.fT1OverSeasRate) / 10000
          const t1weixin = (rateInfo.fWxT1Rate) / 10000
          const t1Alipay = (rateInfo.fAliT1Rate) / 10000

          const t0Debit = (rateInfo.fT0DebitRate) / 10000
          const t0Credit = (rateInfo.fT0CreditRate) / 10000
          const t0OverSeas = (rateInfo.fT0OverSeasRate) / 10000
          const t0FixFee = (rateInfo.fT0FixedFee) / 1000000
          const t0weixin = (rateInfo.fWxT0Rate) / 10000
          const t0Alipay = (rateInfo.fAliT0Rate) / 10000

          const t1UnionDebit = (rateInfo.fT1UnionpayDebitRate) / 10000
          const t1UnionCredit = (rateInfo.fT1UnionpayCreditRate) / 10000
          const t0UnionDebit = (rateInfo.fT0UnionpayDebitRate) / 10000
          const t0UnionCredit = (rateInfo.fT0UnionpayCreditRate) / 10000
          const t0UnionDebitLv2 = (rateInfo.fT0UnionpayDebitRateLv2) / 10000
          const t0UnionCreditLv2 = (rateInfo.fT0UnionpayCreditRateLv2) / 10000
          const t1UnionpayDebitMaxCharge = rateInfo.fT1UnionpayDebitMaxCharge / 1000000
          const t1BelowUnionCreditRate = rateInfo.fT1UnionpayCreditRateLv2 / 10000
          const t1BelowUnionDebitRate = rateInfo.fT1UnionpayDebitRateLv2 / 10000

          const posLower = rateInfo.fPosLowerDivideCent / 10000
          const scanLower = rateInfo.fScanLowerDivideCent / 10000
          const unionLower = rateInfo.fUnionLowerDivideCent / 10000

          this.$jquery('.t1DebitCommission').val(t1Debit)
          this.$jquery('.t1DebitMaxFee').val(t1DebitMax)
          this.$jquery('.t1CreditCommission').val(t1Credit)
          this.$jquery('.t1OverSeasCommission').val(t1OverSeas)
          this.$jquery('.t1WeixinCommission').val(t1weixin)
          this.$jquery('.t1AlipayCommission').val(t1Alipay)
          this.$jquery('.posLowerDivideCent').val(posLower)

          this.$jquery('.t0DebitCommission').val(t0Debit)
          this.$jquery('.t0CreditCommission').val(t0Credit)
          this.$jquery('.t0OverSeasCommission').val(t0OverSeas)
          this.$jquery('.t0FixFee').val(t0FixFee)
          this.$jquery('.t0WeixinCommission').val(t0weixin)
          this.$jquery('.t0AlipayCommission').val(t0Alipay)
          this.$jquery('.scanLowerDivideCent').val(scanLower)

          this.$jquery('.fT1DebitCommissionBymillion').val(t1UnionDebit)
          this.$jquery('.fT1CreditCommissionBymillion').val(t1UnionCredit)
          this.$jquery('.fT0DebitCommissionBymillion').val(t0UnionDebit)
          this.$jquery('.fT0CreditCommissionBymillion').val(t0UnionCredit)
          this.$jquery('.fT0BelowDebitCommissionBymillion').val(t0UnionDebitLv2)
          this.$jquery('.fT0BelowCreditCommissionBymillion').val(t0UnionCreditLv2)
          this.$jquery('.unionLowerDivideCent').val(unionLower)
          this.$jquery('.fT1UnionpayDebitMaxCharge').val(t1UnionpayDebitMaxCharge)

          this.$jquery('.fT1BelowDebitCommissionBymillion').val(t1BelowUnionDebitRate)
          this.$jquery('.fT1BelowCreditCommissionBymillion').val(t1BelowUnionCreditRate)

          if (rateInfo.fExtraData) {
            this.extraFeeRate = this.$options.data().extraFeeRate
            const extraFeeRate = JSON.parse(rateInfo.fExtraData)
            console.log(extraFeeRate)
            for (const item in this.extraFeeRate.alipay) {
              if (typeof (extraFeeRate.alipay[item]) === 'number') {
                this.$jquery('.' + 'alipay_' + item).val((extraFeeRate.alipay[item]) / 10000)
              } else {
                this.$jquery('.' + 'alipay_' + item).val('')
              }
            }
            for (const item in this.extraFeeRate.wechat) {
              if (typeof (extraFeeRate.wechat[item]) === 'number') {
                this.$jquery('.' + 'wechat_' + item).val((extraFeeRate.wechat[item]) / 10000)
              } else {
                this.$jquery('.' + 'wechat_' + item).val('')
              }
            }
          }

          // 日化
          this.rihuaEntity.wxCategoryCreditCommissionD1 = rateInfo.wxCategoryCreditCommissionD1 / 10000
          this.rihuaEntity.wxCategoryDebitCommissionD1 = rateInfo.wxCategoryDebitCommissionD1 / 10000
        }
      } else {
        if (this.ruleType === 0) {
          this.addForm.FLowerDivideCent = ''
        } else {
          this.$jquery('.t1DebitCommission').val('')
          this.$jquery('.t1DebitMaxFee').val('')
          this.$jquery('.t1CreditCommission').val('')
          this.$jquery('.t1OverSeasCommission').val('')
          this.$jquery('.t1WeixinCommission').val('')
          this.$jquery('.t1AlipayCommission').val('')
          this.$jquery('.posLowerDivideCent').val('')

          this.$jquery('.t0DebitCommission').val('')
          this.$jquery('.t0CreditCommission').val('')
          this.$jquery('.t0OverSeasCommission').val('')
          this.$jquery('.t0FixFee').val('')
          this.$jquery('.t0WeixinCommission').val('')
          this.$jquery('.t0AlipayCommission').val('')
          this.$jquery('.scanLowerDivideCent').val('')

          this.$jquery('.fT1DebitCommissionBymillion').val('')
          this.$jquery('.fT1CreditCommissionBymillion').val('')
          this.$jquery('.fT0DebitCommissionBymillion').val('')
          this.$jquery('.fT0CreditCommissionBymillion').val('')
          this.$jquery('.unionLowerDivideCent').val('')
          this.$jquery('.fT1UnionpayDebitMaxCharge').val('')

          this.$jquery('.fT1BelowDebitCommissionBymillion').val('')
          this.$jquery('.fT0BelowDebitCommissionBymillion').val('')
          this.$jquery('.fT1BelowCreditCommissionBymillion').val('')
          this.$jquery('.fT0BelowCreditCommissionBymillion').val('')
          for (const item in this.extraFeeRate.alipay) {
            this.$jquery('.' + 'alipay_' + item).val('')
          }
          for (const item in this.extraFeeRate.wechat) {
            this.$jquery('.' + 'wechat_' + item).val('')
          }
        }
      }
    },
    /**
       * 新增/编辑模板费率table合并行方法
       */
    editTemplateTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === 'D+0单笔手续费') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    /**
       * 新增/编辑模板费率table合并行方法-扫码费率特殊处理
       */
    editTemplateTableSpanMethod2 ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 13,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === '类型') {
        if (rowIndex === 0) {
          return {
            rowspan: 8,
            colspan: 1
          }
        } else if (rowIndex === 8) {
          return {
            rowspan: 5,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    clickExtraRate (type, key) {
      console.log(this.dataParam.extraFeeRate[type][key], type, key, 'clickcccccccccccccc')
      if (this.dataParam.extraFeeRate[type][key] === '' || this.dataParam.extraFeeRate[type][key] === undefined || this.dataParam.extraFeeRate[type][key] === null) {
        this.$message({
          showClose: true,
          message: '代理商未开通此通道交易，无法设置费率',
          type: 'warning'
        })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.getTemplateList()
    })
  },
  mounted () {
    this.getPro()
    this.getBank()
    this.getRate()
    this.getAgentIdOptions()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .demo-inline-form {
    margin-top: 18px;
  }
  .demo-form-inline {
    display: inline-block;
    float: right;
  }

  .btm-action {
    margin-top: 20px;
    text-align: center;
  }

  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  .list h3 {
    margin-bottom: 14px;
  }

  .tab-tag{
    height:0;
    padding: 0;
    line-height: 0;
    background: transparent;
  }
  .dsn{
    display: none;
  }
  .submit{
    margin-left: 10px;
  }
  .check{
    margin-left: 2%;
  }
  .posListTittle{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 16%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-top: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}

  }
  .posList{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    li{
      width: 16%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}

  }

  .scanListTittle{
    width: 75%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 24%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-top: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    // input {border: 0;width: 75%; text-align: center;}
    //  .el-input__inner {border: 0; text-align: center;}

  }
  .scanList{
    width: 75%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 24%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-bottom: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;border-bottom: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input:last-child {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}

  }
  .lastScanList{
    width: 75%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 24%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-bottom: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;border-bottom: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input:last-child {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}
  }

  .unionMerListTittle{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    li{
      width: 19%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;}
    li:last-child{ border-right: 0;}
    li:first-child{ border-left: 1px solid #ccc;}

  }
  .unionMerList{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    //border-bottom: 1px solid #ccc;

    li{
      width: 19%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;}
    li:last-child{ border-right: 0;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}
  }
  .lastUnionMerList{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    li{
      width: 19%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;}
    li:last-child{ border-right: 0;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}
  }

  .fenchengList{
    width: 70%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 16%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;}
    li:last-child{ border-right: 0;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}}
  .posList:first-child{ border-top: 1px solid #ccc;}
  .posList:last-child{ border-bottom: 1px solid #ccc;}

  .branch-input{
    width:255px;
  }
  .el-table input,.scanLowerDivideCent{
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: calc(100% - 20px);
    text-align: center;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    +span{
      height: 30px;
      line-height: 30px;
      margin-left: 5px;
    }
  }
  .el-input{
    span{
      line-height: 40px;
      color: #606266;
      font-size: inherit;
    }
  }
  .two-table {
    display: flex;
    .cutom-table {
      margin-right: 60px;
      .row {
        display: flex;
        align-items: center;
        &.title {
          background: #F5F7FA;
        }
        .item {
          padding: 10px;
          width: 200px;
          &.left {
            width: 150px;
          }
        }
      }
    }
  }
  .row {
    display: flex;
    .item {
      padding: 8px;
      width: 180px;
      box-sizing: content-box;
      text-align:center;
      border-right: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
      &:first-child {
        border-left: 1px solid #EBEEF5;
      }
    }
  }
</style>
<style lang="scss">
  .addAgentForm{
    .el-collapse-item__header{
      border-left: 1px solid #EBEEF5;
      border-right: 1px solid #EBEEF5;
      padding-left: 20px;
      line-height: 1;
      background: #F5F7FA;
      color: #909399;
    }
    .el-collapse-item__wrap{
      border-bottom: none;
    }
  }
</style>
